import { z } from "zod"

const aspectRatioValues = ["16:9", "9:16", "1:1"] as const
export const aspectRatio = z.enum(aspectRatioValues)
export const aspectRatios = z.enum(aspectRatioValues).array()
export type AspectRatio = z.infer<typeof aspectRatio>
export type AspectRatios = z.infer<typeof aspectRatio>
export type AspectRatioValue = (typeof aspectRatioValues)[number]

const CommonData = z.object({
  sermonId: z.number(),
  start: z
    .string()
    .refine((value) => {
      if (value === null || value === undefined) {
        return true
      }
      return value.match(/^[0-9]{2}:[0-9]{2}:[0-9]{2}$/) !== null
    })
    .or(z.null()),
  end: z
    .string()
    .refine((value) => {
      if (value === null || value === undefined) {
        return true
      }
      return value.match(/^[0-9]{2}:[0-9]{2}:[0-9]{2}$/) !== null
    })
    .or(z.null()),
  crop: z
    .object({
      aspectRatios,
    })
    .nullish(),
  modifiedBy: z.string(),
})

const TrimJob = z.object({
  type: z.literal("trim"),
  videoUrl: z.string(),
})

const YoutubeJob = z.object({
  type: z.literal("youtube"),
  youtubeUrl: z.string(),
})

export const JobSchema = z.object({
  id: z.string(),
  data: z.intersection(
    CommonData,
    z.discriminatedUnion("type", [TrimJob, YoutubeJob])
  ),
})

export type Job = z.infer<typeof JobSchema>

export const videoSourceSchema = z.object({
  renderUrl: z.string(),
  serveUrl: z.string(),
  aspectRatio,
})

export type VideoSource = z.infer<typeof videoSourceSchema>

export const Segment = z.object({
  url: z.string().url(),
  // indexed to full audio timeline
  startFromFrame: z.number(),
  endFrame: z.number(),
})

export const SermonJob = z.object({
  sermonId: z.number(),
  videoSources: z.array(videoSourceSchema),
  audioUrl: z.string().url(),
  audioSegments: z.array(Segment),
  modifiedBy: z.string(),
})
export type SermonJob = z.infer<typeof SermonJob>

export const AutoflipJobSchema = z.object({
  id: z.string(),
  data: SermonJob.extend({
    aspectRatios: aspectRatios,
  }),
})

export type AutoflipJob = z.infer<typeof AutoflipJobSchema>["data"]
